import React, { useContext, useState } from 'react';
import { LanguageContext } from '../../App';
import {
  PhoneIcon,
  EnvelopeIcon as MailIcon,
  MapPinIcon as LocationMarkerIcon,
} from '@heroicons/react/24/outline';

const translations = {
  en: {
    title: 'Contact Us',
    subtitle: 'Get in touch with us',
    name: 'Your Name',
    email: 'Email Address',
    message: 'Message',
    send: 'Send Message',
    success: 'Thank you for your message. We will get back to you soon.',
    address: 'Chheet Ka Purwa, Post – Gauri, District – Fatehpur (Uttar Pradesh), India',
    phone: '+91 95409 36061',
    emailAddress: 'rksstrust00@gmail.com',
    officeHours: 'Office Hours',
    officeHoursText: 'Monday - Saturday: 9:00 AM - 6:00 PM',
    contactInfo: 'Contact Information'
  },
  hi: {
    title: 'संपर्क करें',
    subtitle: 'हमसे जुड़ें',
    name: 'आपका नाम',
    email: 'ईमेल पता',
    message: 'संदेश',
    send: 'संदेश भेजें',
    success: 'आपके संदेश के लिए धन्यवाद। हम जल्द ही आपसे संपर्क करेंगे।',
    address: 'ग्राम – छीट का पुरवा, पोस्ट – गौरी, जिला – फतेहपुर (उत्तर प्रदेश)',
    phone: '+91 95409 36061',
    emailAddress: 'rksstrust00@gmail.com',
    officeHours: 'कार्यालय समय',
    officeHoursText: 'सोमवार - शनिवार: सुबह 9:00 - शाम 6:00',
    contactInfo: 'संपर्क जानकारी'
  }
};

const Contact: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically send the data to your backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="py-12 bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">{t.title}</h1>
          <p className="text-xl text-gray-600">{t.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            {submitted ? (
              <div className="text-center py-12">
                <p className="text-xl text-primary">{t.success}</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                    {t.name}
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    {t.email}
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                    {t.message}
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={4}
                    required
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-primary text-white py-3 rounded-md hover:bg-primary/90 transition-colors"
                >
                  {t.send}
                </button>
              </form>
            )}
          </div>

          {/* Contact Information */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-2xl font-bold mb-6">{t.contactInfo}</h2>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <LocationMarkerIcon className="h-6 w-6 text-primary flex-shrink-0" />
                <div>
                  <p className="text-gray-700">{t.address}</p>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <PhoneIcon className="h-6 w-6 text-primary flex-shrink-0" />
                <p className="text-gray-700">{t.phone}</p>
              </div>

              <div className="flex items-center space-x-4">
                <MailIcon className="h-6 w-6 text-primary flex-shrink-0" />
                <p className="text-gray-700">{t.emailAddress}</p>
              </div>

              <div className="pt-6 border-t border-gray-200">
                <h3 className="text-lg font-semibold mb-2">{t.officeHours}</h3>
                <p className="text-gray-700">{t.officeHoursText}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 